"use client";

import { createContext, useContext } from "react";

export const DomainContext = createContext<{
  domain: "shopsite" | "whitelabel";
  requiresCookieConsent: boolean;
} | null>({ domain: "shopsite", requiresCookieConsent: true });

export function useIsShopsite() {
  const context = useContext(DomainContext);
  if (context === null) {
    throw new Error(
      "useIsShopsite must be used within a DomainContextProvider"
    );
  }
  return context.domain === "shopsite";
}

export function useRequiresCookieConsent() {
  const context = useContext(DomainContext);
  if (context === null) {
    throw new Error(
      "useRequiresCookieConsent must be used within a DomainContextProvider"
    );
  }
  return context.requiresCookieConsent;
}

export function DomainContextProvider({
  children,
  domain,
  requiresCookieConsent,
}: {
  children: React.ReactNode;
  domain: "shopsite" | "whitelabel";
  requiresCookieConsent?: boolean;
}) {
  return (
    <DomainContext.Provider
      value={{ domain, requiresCookieConsent: !!requiresCookieConsent }}
    >
      {children}
    </DomainContext.Provider>
  );
}
